export const readablePayoutType = {
  ONCE: 'life-annuity.payout-types.once',
  RECURRING: 'life-annuity.payout-types.recurring',
  COMBINED: 'life-annuity.payout-types.combined'
}
